export default {
  development: {
    apiProtocol: 'https',
    apiHost: 'dev-api.heidelpay.com',
    apiVersion: 'v1',
  },
  staging: {
    apiProtocol: 'https',
    apiHost: 'stg-api.heidelpay.com',
    apiVersion: 'v1',
  },
  production: {
    apiProtocol: 'https',
    apiHost: 'api.heidelpay.com',
    apiVersion: 'v1',
  },
}
  